import isNumber from 'lodash-es/isNumber';
import { PAGE_SLUG } from 'mk/autogenerated/translations/HerBazaar.sagas.ce3339d3f23ed553b03fdc4c8d83b678'
import { bazaar_api_v3_products_url } from 'mk/urls/functions';
import { FacetsData } from 'mk2/apps/bazaar/components/FacetsFilter';
import { ITEMS_PER_PAGE } from 'mk2/apps/bazaar/constants';
import {
    herBazaarLoadApi,
    Checked,
    HerBazaarLoadAction,
    HerBazaarLoadNormalizedResponse,
    HER_BAZAAR_LOAD,
} from 'mk2/apps/bazaar/containers/HerBazaar/HerBazaar.actions';
import { FilterType } from 'mk2/apps/bazaar/schemas';
import { handleXHRGetErrorSaga, normalizeError, XHRAction, XHRGetError } from 'mk2/helpers/api';
import { getLogger } from 'mk2/logger';
import { getRoutingLocation } from 'mk2/selectors';
import { redirectInPWASaga } from 'mk2/services/browserHistory';
import React from 'react';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';

const logger = getLogger('bazaar/HerBazaar.sagas');

interface LoadApiResponse {
    body: {
        facets: FacetsData;
        hits: number;
        checked: Checked;
        entities: HerBazaarLoadNormalizedResponse['entities'],
        result: HerBazaarLoadNormalizedResponse['result'],
    };
}

function* load({ xhr, username, filter }: HerBazaarLoadAction & XHRAction) {
    yield put(herBazaarLoadApi.request(username, filter));

    const { page, start } = filter;

    try {
        const response: LoadApiResponse = yield call(() =>
            xhr.post(bazaar_api_v3_products_url(), {
                filter,
                filterType: FilterType.HER_BAZAAR,
            }),
        );

        yield put(
            herBazaarLoadApi.success(
                username,
                filter,
                response.body.facets,
                response.body.hits,
                response.body.checked,
                {
                    entities: response.body.entities,
                    result: response.body.result,
                },
            ),
        );
    } catch (error) {
        if (error.status === 404 && error.response && error.response.body.page && page !== error.response.body.page) {
            const newPage = error.response.body.page;
            const location = yield select(getRoutingLocation);
            const url = `${location.pathname}${location.search}${location.hash}`;
            yield redirectInPWASaga(
                url.replace(new RegExp(`${PAGE_SLUG}-\\d+/`), newPage === 1 ? '' : `${PAGE_SLUG}-${newPage}/`),
                302,
            );
        } else {
            yield handleXHRGetErrorSaga(error as XHRGetError, logger);
            yield put(herBazaarLoadApi.failure(username, filter, normalizeError(error)));
        }
    }
}

export default function* root() {
    yield all([takeLatest(HER_BAZAAR_LOAD, load)]);
}
